const menuData = [
    {
      id        : 1,
      title     : 'لیست نمایندگی ها',
      nameRoute : 'listRepresentation',
      selected  : false,
    },
    // {
    //   id        : 3,
    //   title     : 'لیست سالن ها',
    //   nameRoute : 'listSalonsOwner',
    //   selected  : false,
    // },
    {
      id        : 4,
      title     : 'پرداخت سیستم به سالن ها',
      nameRoute : 'paySalonOwner',
      selected  : false,
    },
    {
      id        : 5,
      title     : 'لیست سالنداران',
      nameRoute : 'listSalonOwner',
      selected  : false,
    },
    {
      id        : 6,
      title     : 'توضیحات نیاز به بازیکن',
      nameRoute : 'playerDescription',
      selected  : false,
    },
    {
      id        : 7,
      title     : 'پرداخت های سیستم به نمایندگان',
      nameRoute : 'payRepresentation',
      selected  : false,
    },
    {
      id        : 8,
      title     : 'توضیحات رزروهای دنگی',
      nameRoute : 'descriptionDayReservation',
      selected  : false,
    },
    {
      id        : 9,
      title     : 'نظرات سالن',
      nameRoute : 'commentSalons',
      selected  : false,
    },
    {
      id        : 10,
      title     : 'لیست بازیکنان',
      nameRoute : 'listPlayer',
      selected  : false,
    },
    {
      id        : 11,
      title     : 'مدیریت پورسانت و جنسی',
      nameRoute : 'managementCommissionAndGender',
      selected  : false,
    },
    {
      id        : 12,
      title     : 'گردش کیف پول بازیکن',
      nameRoute : 'walletPlayer',
      selected  : false,
    },
    {
      id        : 13,
      title     : 'نظرات سالنها',
      nameRoute : 'commentSalons',
      selected  : false,
    },
    {
      id        : 14,
      title     : 'لیست جام ها',
      nameRoute : 'listCups',
      selected  : false,
    },
    // {
    //   id        : 16,
    //   title     : 'تیم ها',
    //   nameRoute : 'Team',
    //   selected  : false,
    // },
  ]

export default menuData;